<template lang="pug">
  .module__main
    .module-content__container(v-loading="isFinishErrorServiceLoading")
      .service__container
        .service__title Заявки с ошибками завершения
        el-button(type="primary" @click="activateService('finish_error')") Завершить
    el-dialog(
      :visible.sync="isFinishErrorServiceActivated"
      :before-close="resetService"
      title="Завершение заявок"
      width="30%"
    )
      .h3 Введите данные
      .exchange-finish__container
        .exchange-finish__input
          .input__title Количество дней
          el-input-number(v-model="finishError.days" :min="1" :max="14" type="number" placeholder="Количество дней")
        .exchange-finish__buttons
          el-button(type="success" @click="startRestartFinishErrorOrders()") Завершить
          el-button(type="danger" @click="resetService()") Отменить
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import { RESTART_FINISH_ERROR_ORDERS } from "../../store/const/orders";
import instruments from '../../mixins/instruments';

export default {
  name: "Service",
  mixins: [
      instruments,
  ],
  data() {
    return {
      activatedService: '',
      finishError: {
        days: 0,
      }
    }
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    isFinishErrorServiceLoading() {
      return this.loading(RESTART_FINISH_ERROR_ORDERS) === 'loading';
    },
    isFinishErrorServiceActivated() {
      return this.activatedService === 'finish_error';
    },
  },
  methods: {
    ...mapActions('orders', {
      restartFinishErrorOrders: RESTART_FINISH_ERROR_ORDERS,
    }),
    activateService(service) {
      this.activatedService = service;
    },
    resetService() {
      this.activatedService = '';
    },
    async startRestartFinishErrorOrders() {
      this.$confirm(`Вы уверены, что хотите завершить заявки с ошибками?`, 'Подтверждение').then(async () => {
        const request = await this.restartFinishErrorOrders(this.finishError.days);
        await this.notifyRequestResult({
          request,
          methodOnSuccess: this.resetService,
        })
      }).catch(() => {
        this.$message.info('Добавление отменено');
      });
    },
  }
}
</script>
<style>
.service__container {
  width: fit-content;
  padding: 8px;
  background-color: #efefef;
  border-radius: 4px;
  border: 1px solid #bdbaba;
  text-align: center;
}

.service__title {
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 8px;
}
</style>
